<template>
    <transition name="fade">
        <div class="movies page">
            <div class="featured" v-if="vod[0] && vod[0].vods && vod[0].vods.length > 0">
                <div class="header">
                    <h1> On Demand</h1>

                    <div class="dice" v-ripple @click="randomPick">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                            <path d="M22 6.99999C19 6.99999 13.5 6.99999 11.5 12.5C9.5 18 5 18 2 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20 5C20 5 21.219 6.21895 22 7C21.219 7.78105 20 9 20 9" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M22 18C19 18 13.5 18 11.5 12.5C9.5 6.99999 5 7.00001 2 7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20 20C20 20 21.219 18.781 22 18C21.219 17.219 20 16 20 16" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>

                </div>

                <Transition name="fade">
                    <div class="cover" v-show="!moving"><img :src="vod[0].vods[0].backdrop_path" ref="cover"/></div>
                </Transition>

                <Flicking ref="flicking" :options="{ align: 'prev', mode: 'strict', class: 'features', circularFallback: 'bound' }" class="features" @move-end="updateBG($event)"  @move-start="$event => startBG($event)" :plugins="plugins">
                    <router-link v-for="(v, i) in vod[0].vods" :to="`/${v.type}/${v.id}`" :key="i" class="pannel" :id="i" v-ripple>
                        <div class="feature" v-ripple>
                            <div>
                                <div class="poster"><img :src="v.poster_path"/></div>
                                <h3> {{ v.name || v.title }} </h3>
                            </div>
                        </div>
                    </router-link>

                    <div slot="viewport" class="flicking-pagination"></div>
                </Flicking>
            </div>

            <div style="margin-top:75px">
                <div v-if="saved.length > 0" class="content">
                    <h2> Your Library</h2>

                    <div class="content-row" >
                        <div v-for="(media, i) in saved" :key="i">
                            <Saved :saved="media" />
                        </div>
                    </div>
                </div>

                <div v-if="history.length > 0" class="content">
                    <h2> Continue Watching</h2>

                    <div class="content-row" >
                        <div v-for="(media, i) in history" :key="i">
                            <History :history="media" />
                        </div>
                    </div>
                </div>
            </div>

          <div class="content">
            <div class="content-g">
                <h2> Inspired By Your Activity </h2>
                <div class="content-row">
                    <div v-for="(media, i) in reccomendations" :key="i">
                        <Movie :media="media" ref="media" :list="true" :display="true" v-ripple/>
                    </div>
                </div>
            </div>
          </div>

          <transition name="fade">
              <div class="content">
                <div class="content-g" v-for="(v, k) in vod" :key="k">
                    <h2 v-if="v.name"> {{ v.name }} </h2>
                    <div class="content-row" v-if="v.name"  @scroll="(e) => {handleScroll(e.target, v, k)}" >
                        <div v-for="(media, i) in v.vods" :key="i" >
                            <Movie :media="media" ref="media" :list="true" :display="true" v-ripple/>
                        </div>
                    </div>
                </div>
              </div>
          </transition>
      </div>

    </transition>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";

import { Perspective, Pagination } from "@egjs/flicking-plugins";
import History from "@/components/VodHistory.vue";
import Saved from "@/components/Saved.vue";


// @ is an alias to /src
const Movie = () => import('@/components/Movie.vue')

export default {
  name: 'Movies',

  components: {
    Movie,
    History,
    Saved,
    Flicking: Flicking

  },

  computed: { },

  data: function(){
    return {
        plugins: [new Perspective({ rotate: 0.25 }), new Pagination({ type: 'scroll' })],

        vod: [],
        history: [],
        saved: [],
        loading: [],
        moving: false,

        reccomendations: [{id: '', type: '', title: 'Loading...'}, {id: '', type: '', title: 'Loading...'}, {id: '', type: '', title: 'Loading...'}],
        activeFeature: {id: '', name: 'loading...'},
        activeGenre: {id: '', name: 'loading...'},
        activeYear: {id: '', name: 'loading...'},

        genres: window.genres,
        features: window.features,

        letLoadingResults: false
    }
  },

  activated: function () {
    this.getSaves()
    document.title = `Stream TV and Movies - QB`
  },

  mounted: async function(){
    document.title = `Stream TV and Movies - QB`
    this.getSaves()
    this.activeGenre = this.genres[Math.floor(Math.random() * this.genres.length)];
    this.activeFeature = this.features[Math.floor(Math.random() * this.features.length)];
    this.activeYear = {
        id: 'year',
        name: `${Math.floor(Math.random() * (new Date().getFullYear() - 1990 + 1)) + 1990}`
    }


    const t = [
        { section: "", query: 'sort_by=popularity.desc&vote_count.gte=2000', page: 1 },
        { section: "Popular", query: 'sort_by=popularity.desc&vote_count.gte=1000', page: 2 },
        { section: "Critically Acclaimed", query: 'sort_by=vote_average.desc&vote_count.gte=3000', page: 1 },
        { section: "New and Noteworthy", query: 'sort_by=primary_release_date.desc&vote_count.gte=100', page: 1 },

        { section: "More to Love", query: 'sort_by=primary_release_date.desc&vote_average.gte=7&vote_count.gte=500', page: 1 },
        { section: "Find Something New", query: 'vote_average.gte=8&sort_by=release_date.desc&with_runtime.gte=90', page: 1 },

        { section: "Box Office Hits", query: 'sort_by=revenue.desc', tv: false, page: 1 },
        //{ section: "Star Studded Casts", query: 'sort_by=revenue.desc', page: 1, tv: false },

        { section: "Instant Classics", query: 'sort_by=popularity.desc&primary_release_year.lte=2010&vote_average.gte=8', tv: false, page: 1 },
        { section: `Best of ${this.activeYear.name}`, query: `primary_release_year=${this.activeYear.name}&sort_by=vote_count.desc`, tv: false, page: 1 },
        { section: `Best of ${this.activeGenre.name}`, query: `with_genres=${this.activeGenre.id}&sort_by=popularity.desc`, tv: false, page: 1 },
        { section: `Best of ${this.activeFeature.name}`, query: `with_people=${this.activeFeature.id}&sort_by=popularity.desc`, tv: false, page: 1 },

        { section: "Hidden Gems", query: 'vote_count.lte=100&vote_average.gte=7&popularity.lte=25', page: 1 },
        { section: "Fan Favorites", query: 'sort_by=vote_average.desc&vote_count.gte=1500', page: 1 },
        { section: "Trending", query: 'sort_by=primary_release_date.desc&vote_count.gte=25 ', page: 1 },
        { section: "New & Upcoming Releases", query: 'sort_by=primary_release_date.desc', page: 1 }
    ]

    for(const x of t){
        await this.loadMedia(x.section, x.query, x.page, x.tv, false)
    }

  },

  methods: {
    async handleScroll(container, v, k) {
      const isAtEnd = container.scrollLeft + container.clientWidth >= (container.scrollWidth - 775);
      if (isAtEnd && !this.loading[k]) {
          this.loading[k] = true 
          const newmedia = await this.loadMedia(v.name, v.query, v.page, v.tv, true)
          const section = this.vod.find(x => x.name === v.name)
          section.page = newmedia.page
          section.vods = [...section.vods, ...newmedia.vods]
          this.loading[k] = false
      }
    },
    randomPick(){
        const n = Math.floor(Math.random() * this.vod.length)
        const i = Math.floor(Math.random() * this.vod[n].vods.length)
        this.$router.push({ path: `/${this.vod[n].vods[i].type}/${this.vod[n].vods[i].id}` })
    },

    async getSaves(){
        const saved  = await window.afetch(`/save?group=od`)
        const savedRes =  await saved.json()
        this.saved = savedRes.saves
        this.history = savedRes.history.reverse()
        this.getReccomendations()
    },

    async getReccomendations(){
        const reccos = await window.afetch('/ai-vod-reccomendations', {
            method: 'POST',
            body: JSON.stringify({
                media: this.history.map(x => x.name),
            })
        })
        const data =  await reccos.json()
        this.reccomendations = data.reccomendations
    },

    startBG(){ this.moving = true },

    updateBG(){
        this.$nextTick(() => {
            this.$refs.cover.src = this.vod[0].vods[this.$refs.flicking.currentPanel.index].backdrop_path
            this.$nextTick(() => {
                this.moving = false
            })
        })

    },

    async loadMedia(name, query, page, tv=true, update){
        let media = []
        const movieresponse  = await window.afetch(`/discover`, {
            method: 'POST',
            body: JSON.stringify({
                page: page,
                query: query,
                type: 'movie',
            })
        })
        const movieData =  await movieresponse.json()
        media = [...movieData.media]

        if(tv){
            const showresponse  = await window.afetch(`/discover`, {
                method: 'POST',
                body: JSON.stringify({
                    page: page,
                    query: query,
                    type: 'tv',
                })
            })
            const showData =  await showresponse.json()
            media = [...media, ...showData.media]
        }
        if(!update){
            this.vod.push({name, page: page + 1, query, vods: window.shuffle(media)})
        }else{
            return {name, page: page + 1, query, vods: window.shuffle(media)}
        }
    }
  }
}
</script>

<style>
    .flicking-pagination.flicking-pagination-scroll{
        position: relative;
    }
    .flicking-pagination{
        position: absolute;
        bottom: 60px;
        left: calc(100vw - 100px);

    }
    .flicking-pagination-bullet{
        background-color: white!important;
        opacity: 0.1;
    }

    .flicking-pagination-bullet-active{
        opacity: 1;
    }

</style>
<style scoped lang="scss">
.header{
    width: calc(100vw - 40px);
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    z-index: 1;
    margin-top: 20px;
    top: 0;
    left: 0;

    .dice{
        padding: 10px;
        backdrop-filter: blur(20px);
        background-color: rgba(255,255,255,0.1);
        border-radius: 5px;
        width: 20px;
        height: 20px;
    }
    h1{
        padding: 0;
        margin:0;
        font-weight: bold;
        text-shadow: 0 0px 7px rgba(black, 0.5);
        z-index: 99999;
    }
}

.movies{
    position: relative;
    width: 100vw;
    height: auto;
}
.featured{
    height: 60vh;
    min-height: 400px;
    position: relative;
    display: flex;
    z-index: 1;
    align-items: center;
    justify-content: center;
    // overflow: hidden;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    color: white;
    width: 100vw;
    a{
    color: white;

    }
    .flicking-viewport{
        height: 100%;
        padding-top: 150px;
        transition: none;
    }

    .features{
        padding-left: 10vw;
        .feature{
            position: relative;
            min-width: 70vw;
            width: 70vw;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-shadow: 0 0px 7px rgba(black, 0.5);
        }

    }
    .poster{
        height: 50vh;
        min-height: 300px;
        img{
            height: 100%;
            border-radius: 15px;
            width: auto;
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);
        }

    }
    h3{
        font-size: 9px;
        text-transform: uppercase;
        max-width: 250px;
        letter-spacing: 3px;
        padding-top: 10px;
        position: relative;
        left: -15px;

    }
    .cover{
        position: absolute;
        width: 110%;
        left: -5%;
        top: 0;
        height: 110%;
        filter: blur(20px);
        z-index: -2;
        img{
            height: 100%;
            min-width: 110vw;
            object-fit: cover;
        }
    }
}
.content{
    position: relative;
    z-index: 2;
    h2{
        font-size: 14pt;
        padding: 20px;
        margin-bottom: 0px;
        margin-top: 0;
        position: relative;
        svg{
            position: relative;
            width: 20px;
            top: 4px;
        }
    }

}

</style>
